import React from 'react'

import { Link } from 'gatsby'
import $ from 'jquery'

//Helpers
import {
  getLocation,
  getName,
  getFakeAddress,
  getStatus,
  is_Sold,
} from '@helpers/helper.developments'
import { getCover, getQuality, getPriceForMarker } from '@helpers/helper.rendering'
import { getMinAndMaxPrice } from '@helpers/helper.unities'
import {
  getEnvironment,
  getPrices,
  getRegion,
  getSurface,
  makeLink,
} from '@helpers/helper.properties'
import { Development, Property, RealEstateDataPageComponentData } from 'types'
import Loader from '@components/loader/1'
import { useInView } from 'react-intersection-observer'
// import { changeSelectedAction } from '../../../../redux/propertiesDucks'

interface Props {
  dispatch?: any
  inMap?: boolean
  unities?: Property[]
  development?: Development
  skeleton?: boolean
}

const developmentCard = (props: Props & RealEstateDataPageComponentData) => {
  const { dispatch, development, skeleton, global_data } = props
  const { divisionPath } = global_data
  const { button } = global_data.content.cardsDevelopments.data

  const { ref, inView } = useInView({
    triggerOnce: true, // Cargar solo una vez cuando sea visible
  })

  const inMap = props?.inMap

  if (skeleton || !inView) {
    return (
      <div
        ref={ref}
        className="card-dev-7 skeleton"
      >
        {(skeleton || !inView) && <Loader />}
      </div>
    )
  }

  const toggleModal = () => {
    document.body.classList.remove('modal-open')
    // const element = document.getElementById('exampleModal') as HTMLElement
    // element.remove()
    $('#exampleModal').hide()
    $('.modal-backdrop').hide()
    // const modal: any = document.getElementById('exampleModal')
    // modal.classList.remove('show')
    // modal.style.display = 'none'
    document.body.classList.remove('modal-open')
    document.body.style.overflow = 'auto'
  }

  return (
    <div
      ref={ref}
      className={'card-dev-7 ' + (inMap ? 'map-card' : '')}
    >
      <div className={'card-image grid_map_image'}>
        <img
          src={!skeleton ? getQuality(getCover(development!.photos)) : ''}
          className="notScale"
          alt="Development card image"
        />
        <div className="badges">
          <p className={'badge'}>{'EMPRENDIMIENTO'}</p>
        </div>
        <div
          onClick={() => toggleModal()}
          data-bs-dismiss="modal"
          className="close-card"
        >
          <i></i>
          <i></i>
        </div>
      </div>
      <div className="card-body">
        <div className="content d-flex justify-content-between align-items-center">
          <div className="left">
            <h5 className="mb-2">{development?.name}</h5>
            <p>
              {development &&
                getLocation(development, true)?.at(0) +
                  ', ' +
                  getLocation(development, true)?.at(1)}
            </p>
          </div>
          <div className="right">
            <Link
              to={
                (divisionPath ?? '') +
                '/emprendimiento/' +
                getFakeAddress(development!)
                  ?.replaceAll(' ', '-')
                  ?.replaceAll('/', '-')
                  ?.toLowerCase() +
                '/' +
                development?.id
              }
            >
              <i className="icon-arrow-stick-light"></i>
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default developmentCard
